export default __webpack_public_path__ + "static/media/Community_Service.bdf0f840.jpg";